module.exports = __webpack_public_path__ + "static/media/icon_exit.9336eb39.svg";